import Vue from 'vue';
import Vuex from 'vuex';

import DashboardModule from './modules/cart';

Vue.use(Vuex);

const state = {};
const getters = {};
const actions = {};
const mutations = {};

const store = new Vuex.Store({
    strict: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        DashboardModule,
    }
});

export default store;
